"use client";

import { ReactNode } from "react";
import { usePathname } from "next/navigation";
import SiteHeader from "@/components/site-header";
import SiteFooter from "@/components/site-footer";

export default function LayoutClientWrapper({
  children,
}: {
  children: ReactNode;
}) {
  const pathname = usePathname();

  const shouldHideHeaderFooter =
    pathname?.startsWith("/partner/property-admin") ||
    pathname?.startsWith("/admin/system-admin") ||
    pathname?.startsWith("/customer/profile/account") ||
    pathname?.startsWith("/customer/profile/bookings") ||
    pathname?.startsWith("/customer/profile/reviews") ||
    pathname?.startsWith("/customer/profile/wishlist") ||
    pathname?.startsWith("/partner/hotelier-dashboard/property-list") ||
    pathname?.startsWith("/partner/hotelier-dashboard/property-admin") ||
    pathname?.startsWith("/tour-guide/tour-guide-dashboard") ||
    pathname?.startsWith("/tour-guide/tour-guide-dashboard/profile") ||
    pathname?.startsWith("/partner/explore/explore-list") ||
    pathname?.startsWith("/partner/dashboard") ||
    pathname?.startsWith("/partner/onboarding") ||
    pathname?.startsWith("/tour-guide/register") ||
    pathname?.startsWith("/partner/explore/explore-partner-registration") ||
    pathname?.startsWith("/partner/transport/transport-register") ||
    pathname?.startsWith("/partner/transport/transport-dashboard");

  return (
    <>
      {!shouldHideHeaderFooter && <SiteHeader />}
      <main className="w-full overflow-x-hidden">{children}</main>
      {/* <main
        className={`w-full overflow-x-hidden ${
          !shouldHideHeaderFooter ? "pt-16 md:pt-20" : ""
        }`}
      >
        + {children}+{" "}
      </main> */}
      {!shouldHideHeaderFooter && <SiteFooter />}
    </>
  );
}
